import React from 'react';
import { CycleDiscountMap } from './CycleDiscountMap';
import { groupRulesByTarget, isSpecificRule } from '../utils';
import { buildOfferSummary } from '../../../Offers/create/create-offer.bootstrap.hook';

// Preço do plano por ciclo já com as regras do grupo — o valor que o usuário
// pensa em "preço final", não o desconto das barras. Sem plano/preço: sem linha.
// Mesma prioridade de preço do editor (add/index.js, DiscountPricePreview).
function getPlanCycleTotal(plan, planId, groupRules) {
  const amount = Number(plan?.price ?? plan?.amount ?? plan?.value);
  if (!plan || !Number.isFinite(amount)) return undefined;
  return (cycle) =>
    buildOfferSummary({ id: planId, amount }, [], { rules: groupRules }, cycle)
      .finalTotal;
}

// Um mapa de ciclos por plano/produto específico — regras gerais aparecem em
// todos, marcadas como "herdado" (o cliente leva um plano só, então regras de
// planos diferentes nunca somam). Sem regra específica, mapa único.
// getPlan(planId), quando informado, adiciona a linha "Plano fica por".
export function CycleDiscountMapGroups({
  rules,
  getTarget,
  getPlan,
  onRuleClick,
}) {
  const groups = groupRulesByTarget(rules);
  if (!groups.length) {
    return (
      <CycleDiscountMap
        rules={rules}
        getTarget={getTarget}
        onRuleClick={onRuleClick}
      />
    );
  }

  // Mesmo número de colunas em todas as seções, pra comparar planos na vertical.
  const minVisible = Math.max(
    ...rules.flatMap((rule) => [
      Number(rule.fromCycle) || 0,
      Number(rule.toCycle) || 0,
    ]),
  );

  return groups.map((group, index) => (
    <div
      key={group.key}
      className="mb-5"
      style={
        index > 0
          ? {
              borderTop: '1px solid var(--border-neutral-default)',
              paddingTop: 'var(--space-24)',
            }
          : undefined
      }
    >
      <h4 className="jds-title-sm mb-2">
        {getTarget?.(group.rule) || 'Sem nome'}
      </h4>
      <CycleDiscountMap
        rules={group.rules}
        getTarget={(rule) =>
          isSpecificRule(rule) ? getTarget?.(rule) : 'herdado'
        }
        getCycleTotal={
          group.rule.scope === 'PLAN'
            ? getPlanCycleTotal(
                getPlan?.(group.rule.planId),
                group.rule.planId,
                group.rules,
              )
            : undefined
        }
        totalLabel="Plano fica por"
        onRuleClick={onRuleClick}
        minVisible={minVisible}
      />
    </div>
  ));
}
